export class HeaderDetail {
  constructor(public headerId: string, public headerValue: string) { }
}
